<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3"><search-form :fields="search"/></el-button-group>

    <el-table :data="goods" resource="goods" v-loading="loading">
      <el-table-column type="index" width="50" label="编号" />

      <el-table-column prop="goodsName" label="商品名" />

      <el-table-column align="center" header-align="center" label="类型">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_type == 0" type="danger">普单</el-tag>
          <el-tag v-if="scope.row.order_type == 1" type="success">报单</el-tag>
          <el-tag v-if="scope.row.order_type == 2">积分订单</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="总库存(件)">
        <template slot-scope="scope">
          {{ scope.row.store_count }} <el-link type="primary" @click="onChangeStoreCount(scope.$index, scope.row)">设置库存</el-link>
        </template>
      </el-table-column>

      <el-table-column prop="store_count" label="总库存(件)" />
      <el-table-column prop="sale_count" label="销量(件)" />
      <el-table-column prop="onlineTotalAmount" label="线上销售额(元)" />
      <el-table-column prop="offlineTotalAmount" label="线下销售额(元)" />
      <el-table-column label="总销售额(元)">
        <template slot-scope="scope">
          {{
            Number(
              Number(scope.row.onlineTotalAmount) + Number(scope.row.offlineTotalAmount == null ? 0 : scope.row.offlineTotalAmount),
            ).toFixed(2)
          }}
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="设置库存" :visible.sync="setStoreCountDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="form"
        :submit="onStoreCountSubmit"
        :errors.sync="errors"
        :form.sync="form"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="库存数量" required prop="store_count">
          <input id="goods_id" name="goods_id" type="hidden" class="form-control" v-model="form.id" />
          <el-input v-model="form.store_count" autofocus />
          <el-alert title="正整数即表示追加库存，负整数表示减库存" type="info" show-icon :closable="false" />
        </el-form-item>
        <el-form-item label="备注" required prop="remark"
          ><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="form.remark"
        /></el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import { goodsSaleStats, changeStoreCount } from '@/api/goods'
import { getMessage, getFirstError } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
import LzForm from '@c/LzForm'

export default {
  name: 'Index',
  components: {
    LzForm,
    SearchForm,
    ButtonLink,
  },
  data() {
    return {
      search: [
        {
          field: 'created_at',
          label: '日期',
          type: 'el-date-picker',
        },
      ],
      goods: [],
      page: null,
      loading: true,
      setStoreCountDialog: false,
      form: {
        id: 0,
        store_count: '',
        remark: '',
      },
      errors: {},
    }
  },
  methods: {
    async loadData(newVal) {
      const data = await goodsSaleStats(newVal)
      this.goods = data.data
      this.loading = false
    },
    async onChangeStoreCount(index, row) {
      this.setStoreCountDialog = true
      this.form = { id: row.goods_id, store_count: '', remark: '' }
    },
    async onStoreCountSubmit() {
      try {
        const { data } = await changeStoreCount(this.form)
        this.$message.success(getMessage('updated'))
        await this.loadData({})
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
      this.setStoreCountDialog = false
      this.clearForm()

      // this.$message.success(getMessage('default'))
      await this.loadData({})
    },
    async onDestroyConfirm(index, row) {
      await destroyGood(row.id)
      this.$message.success(getMessage('destroyed'))
      await this.loadData({})
    },
    async onConfirm(index, row) {
      await updateGoodStatus(row.id)
      this.$message.success(getMessage('updated'))
      await this.loadData({})
    },
    clearForm() {
      this.form = {
        id: 0,
        store_count: '',
        remark: '',
      }
    },
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.loadData(newVal.query)
      },
      immediate: true,
    },
    setStoreCountDialog(newVal) {
      if (!newVal) {
        this.clearForm()
      }
    },
  },
}
</script>
